import type React from 'react';
import { useEffect } from 'react';

export const useClickOutside = (ref: React.RefObject<HTMLElement> | null, onClickOutside: () => void) => {
    useEffect(() => {
        const handleClickOutside = (event: Event) => {
            if (ref && ref.current && !ref.current.contains(event.target as Node)) {
                onClickOutside();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [ref, onClickOutside]);
};
